import { Controller } from "@hotwired/stimulus"

// Minimal wrapper around <dialog>: opened from anywhere by id, closed on backdrop click.
// Connects to data-controller="erp--dialog"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this._onBackdropClick = (event) => {
      if (event.target === this.#dialog()) this.close()
    }
    this.#dialog()?.addEventListener("click", this._onBackdropClick)
  }

  disconnect() {
    this.#dialog()?.removeEventListener("click", this._onBackdropClick)
  }

  open(event) {
    event?.preventDefault()
    this.#dialog()?.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.#dialog()?.close()
  }

  #dialog() {
    return this.hasDialogTarget ? this.dialogTarget : this.element
  }
}
